<template>
  <v-dialog v-model="dialog" persistent max-width="600px" @keydown.esc="close">
    <v-card>
      <!-- layer_popWrap -->
      <div class="dialog-container" style="width: 600px">
        <div class="ksd-header">
          <h1 class="ksd-header-title">레이아웃</h1>
        </div>
        <div class="dataTable" style="padding-top: 15px">
          <div style="max-height: 500px">
            <div class="list list_fa">
              <span
                @click="logDev"
                class="list_title"
                style="font-size: 15px; padding-left: 10px"
                >레이아웃 리스트</span
              >

              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-wrap: wrap;
                  flex-direction: row;
                "
              >
                <div
                  class="layout-img"
                  v-for="(lay, index) in layoutList"
                  :key="index"
                >
                  <!-- ref="star" -->
                  <img
                    :src="`/static/ksd/layout/${lay.name}.PNG`"
                    :title="lay.desc"
                    :class="lay.bindActive ? 'activeTarget' : ''"
                    @click="selectLayout(lay, index)"
                  />
                </div>
              </div>
            </div>
            <!-- /.list -->
            <div
              class="layout_wrap"
              style="padding: 8px; padding-bottom: 0"
              v-if="attendees && attendees.length >= 1"
              :style="{ display: isActive }"
            >
              <div class="left_area">
                <span class="list_title" style="padding-left: 18px"
                  >선택된 레이아웃</span
                >
                <table
                  class="member_list"
                  cellpadding="0"
                  cellspacing="0"
                  style="border: none"
                >
                  <caption>
                    이 표는 구성되어 있습니다.
                  </caption>
                  <colgroup>
                    <col style="width: 30%" />
                    <col style="width: 30%" />
                    <col style="width: 30%" />
                    <col style="width: 30%" />
                  </colgroup>
                  <div style="width: 220px">
                    <img :src="selectedFixLayoutImage" style="width: 87%" />
                  </div>
                </table>
              </div>
              <!-- //.left_area -->
              <div class="right_area" style="padding-left: 5px">
                <span class="list_title">자리지정(선택사항)</span>
                <button
                  v-if="!conferenceRoomActive"
                  class="organization_add_btn"
                  @click="addFixSeat()"
                >
                  추가
                </button>
                <ul class="fix-layout-wrap" style="height: 220px; overflow: auto;">
                  <li :key="obj.id" v-for="obj in fixSeatList">
                    <span class="num">#{{ obj.id }}</span>
                    <v-autocomplete
                      v-model="obj.seat"
                      :items="attendeeList"
                      outline
                      close-text
                      single-line
                      hide-details
                      return-object
                      item-value="key"
                      item-text="name"
                      style="
                        max-width: 220px;
                        font-size: 11px;
                        min-height: 20px;
                        float: left;
                        margin-right: 10px;
                      "
                      class="layout"
                      @change="participantChanged(obj)"
                    ></v-autocomplete>
                    <img
                      v-if="!conferenceRoomActive"
                      @click="deleteFixSeat(obj)"
                      src="../../../src/images/button/btnClose.png"
                    />
                  </li>
                </ul>
              </div>
              <!-- //.right_area -->

              <!-- //.layout_wrap -->
            </div>
          </div>
          <div class="dialog-footer" style="margin-top: 30px; padding-bottom: 0;">
            <button class="btnPrimary" @click="selectedFixSeatList">
              완료
            </button>
            <button class="noIconButton" @click="close">취소</button>
          </div>
          <!-- // .popup_tel_wrap -->
        </div>
        <!-- //<div class="dataTable> -->
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';
import debounce from 'lodash.debounce';

export default {
  components: {},
  props: [
    'dialog',
    'attendees',
    'selectLayoutCode',
    'closeMeetingLayoutDialog',
    'conferenceRoomActive',
    'meeetingFixSeatList',
  ],
  data() {
    return {
      loading: true,
      isActive: 'none',
      error: null,
      selectedLayoutCode: null,
      selectedLayoutImage: null,
      isHelpActive: 'none',
      fixSeatList: [],
      layoutList: [],
      attendeeList: [],
      selectedFixLayoutImage: null,
      bookmarks: [],
      selectedBookmarkList: null,
      checkedMembers: [] /* 체크박스 유저 정보 */,
    };
  },
  watch: {
    dialog: {
      async handler(val) {
        if (val) {
          this.attendeeList = this.attendees.map((a) => {
            return {
              isDevice: a.isDevice ? true : false,
              name: a.isDevice ? a.deviceName : a.name,
              key: a.isDevice ? a.uri : a.empNum,
            };
          });

          this.attendeeList.unshift({ name: '자동선택', key: null });

          if (this.selectLayoutCode === null) {
            this.clearLayout();
            this.isActive = 'none';
          } else {
            await this.init();
            // 설정 된 layout 데이터가 존재 하는 경우
            this.bindMeetingLayout();
          }
        }
      },
    },
  },

  methods: {
    logDev() {
      console.log(`logDev`, this.layoutList);
    },
    async init() {
      await this.getLayoutList();
      this.fixSeatList = [];
      this.fixSeatList.push({ id: 1, seat: null });
      this.error = null;
      this.selectedBookmarkList = null;
      if (this.attendees !== undefined) {
        if (this.attendees.length === 0) {
          this.isActive = 'none';
        } else {
          this.selectedFixLayoutImage = '/static/ksd/layout/layout1.png';
        }
        /* 레이아웃 DB화 해서 개발 예정 */
      }
    },
    async bindMeetingLayout() {
      console.log(`this.selectLayoutCode: `, this.selectLayoutCode)
      if (this.selectLayoutCode) {
        // 선택된 Layout 찾기
        let layoutObj = null;
        let layoutIdx = this.layoutList.findIndex(
          (obj) => obj.layoutCode === this.selectLayoutCode
        );

        if (layoutIdx >= 0) {
          layoutObj = this.layoutList[layoutIdx];
          this.selectLayout(layoutObj, layoutIdx);
        }
      }

      if (this.meeetingFixSeatList && this.meeetingFixSeatList.length >= 1) {
        this.fixSeatList = this.meeetingFixSeatList;
      } else {
        this.fixSeatList = [];
        this.fixSeatList.push({ id: 1, seat: { key: null } });
      }
    },
    async getLayoutList() {
      let params = {
        conferenceRoomActive: this.conferenceRoomActive,
      };
      await this.$http
        .get('/api/v1/meetings/layoutList', { params: params })
        .then((response) => {
          if (response) {
            console.log(response.data);
            this.layoutList = response.data;
            this.layoutList.forEach((l) => {
              l['bindActive'] = false;
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectLayout(layoutObj, index) {
      console.log(`### selectLayout ###`, layoutObj.name);
      this.layoutList.forEach((obj) => {
        if (obj.layoutCode === layoutObj.layoutCode) {
          obj['bindActive'] = true;
        } else {
          obj['bindActive'] = false;
        }
      });
      this.isActive = '';
      this.selectedLayoutCode = layoutObj.layoutCode;
      this.selectedLayoutImage = '/static/ksd/layout/' + layoutObj.name + '.PNG';
      this.selectedFixLayoutImage =
        '/static/ksd/layout/' + layoutObj.name + '.PNG';
    },
    close() {
      if (this.selectLayoutCode === null) {
        this.clearLayout();
        this.$emit('closeMeetingLayoutDialog');
      } else {
        this.$emit('closeMeetingLayoutDialog');
      }
    },
    participantChanged(item) {
      // 다른 위치에 지정 된 사용자를 선택 했을 때, 이전에 지정된 자리를 선택 해제 함.
      console.log(`item`, item);
      if (item.seat) {
        let idx = this.fixSeatList.findIndex(
          (i) => i.id !== item.id && i.seat && i.seat.key === item.seat.key
        );
        if (idx >= 0) {
          this.fixSeatList[idx].seat = {
            key: null,
          };
        }
      }
      // if (this.fixSeatList) {
      //   this.fixSeatList.forEach(obj => {
      //     if (item && item.seat === obj.seat) {
      //       obj.seat = null;
      //     }
      //   });
      // }
    },
    addFixSeat() {
      let length = this.fixSeatList.length + 1;
      let layoutCode = this.selectedLayoutCode;
      if (length > 10) {
        alert('지정자리는 최대 10개까지 가능합니다.');
      } else {
        console.log(this.fixSeatList);
        this.fixSeatList.push({
          id: length,
          seat: {
            key: null,
          },
        });
      }
    },
    selectedFixSeatList() {
      this.$emit(
        'selectedFixSeatList',
        this.selectedLayoutCode,
        this.selectedLayoutImage,
        this.fixSeatList
      );
    },
    deleteFixSeat(obj) {
      const findItem = this.fixSeatList.find((item) => item.id === obj.id);
      const idx = this.fixSeatList.indexOf(findItem);
      this.fixSeatList.splice(idx, 1);

      let num = 0;
      this.fixSeatList.forEach((i) => {
        num++;
        i.id = num;
      });
    },
    clearLayout() {
      this.init();
      this.selectedLayoutCode = null;
      this.selectedLayoutImage = null;
      this.isActive = 'none';

      this.layoutList.forEach((obj) => {
        obj['bindActive'] = false;
      });

      // this.$refs.star.forEach((obj) => {
      //   obj.classList.remove('activeTarget');
      // });
    },
    openHelpDialog() {
      this.isHelpActive = '';
    },
    closeHelpDialog() {
      this.isHelpActive = 'none';
    },
  },
};
</script>
<style scoped>
.dialog-container {
  max-width: 100%;
}
a {
  color: #464646;
  font-weight: 300;
}
.seltabcontent .seltab {
  width: 9%;
}
.p_ad {
  width: 42%;
  border: 1px solid #989898;
  border-radius: 5px;
  padding: 30px 15px 25px 15px;
  position: relative;
  font-weight: 500;
}

.seltab_r .scroll_tit li {
  float: left;
  height: 23px;
  padding-top: 7px;
  padding-bottom: 3px;
  text-align: center;
  border-top: 2px solid #fa4242;
  border-bottom: 1px solid #fa4242;
}

.checkbox {
  position: relative;
  font-size: 12px;
  float: none;
  padding: 0;
}
.checkbox input[type='checkbox'] {
  display: none;
}
.checkbox input[type='checkbox'] + label:before {
  position: unset;
  border: none;
}

.popContainer .checkbox input[type='checkbox'] + label {
  border: 1px solid #7f7f7f;
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #fff;
  cursor: pointer;
  position: unset;
  padding: 0;
}
.popContainer .checkbox :after {
  display: block;
  clear: both;
  content: '';
}
.popContainer .checkbox input[type='checkbox']:checked + label:before {
  position: unset;
  left: 0;
  top: 0;
  background: #fff;
  width: 0;
  height: 0;
  border: none;
}

.popContainer .checkbox input[type='checkbox']:checked + label:after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  background: #fa4242;
}

/* 선택목록 스크롤 바 */
.mCustomScrollbar::-webkit-scrollbar {
  width: 6px;
}
.mCustomScrollbar::-webkit-scrollbar-track {
  background-color: transparent;
}
.mCustomScrollbar::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.mCustomScrollbar::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
.seltab .btn_com {
  display: inline-block;
  width: 60px;
  height: 30px;
  line-height: 30px;
  padding: 0;
  color: white;
}
.btn_com {
  color: white;
}
.btn_linedf {
  color: #fa4242;
}

/* 체크박스 */
.btn_check_box > .container-checkbox {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  float: left;
  margin-right: 10px;
  font-size: 17px;
  width: 100%;
}

.btn_check_box > .container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 30px;
  z-index: 100;
  top: -16px;
  right: 0px;
}

.btn_check_box > .container-checkbox .checkmark {
  position: absolute;
  border: 1px solid #7f7f7f;
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #fff;
  cursor: pointer;
  top: -5px;
  right: 18px;
}

/* On mouse-over, add a grey background color */
.btn_check_box > .container-checkbox:hover input ~ .checkmark {
}

/* When the checkbox is checked, add a blue background */
.btn_check_box > .container-checkbox input:checked ~ .checkmark {
  background-color: white;
}

/* Create the checkmark/indicator (hidden when not checked) */
.btn_check_box > .container-checkbox .checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.btn_check_box > .container-checkbox input:checked ~ .checkmark:after {
  display: block;
  content: '';
  top: 1px;
  left: 1px;
  width: 8px;
  height: 8px;
  background: #fa4242;
}

/* Style the checkmark/indicator */
.btn_check_box > .container-checkbox .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border-width: 0 3px 3px 0;
}

.btn_check_box {
  padding-top: 4px;
}

.bookmark-delete-btn {
  float: right;
  border: none;
  border-radius: 5px;
  background: #0d99de;
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.fix-layout-wrap {
  height: auto;
  overflow: auto;
}

.activeTarget {
  border: 4px solid #1457aa;
  border-radius: 5px;
}
.layout_wrap > .left_area {
  width: 49%;
  padding-left: 25px;
}
.help-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow-y: auto;
  overflow-x: auto;
  text-align: center;
}
.help-img {
  width: 100%;
  max-width: 680px;
  display: inline-block;
  position: relative;
  top: 7%;
}

.close-img {
  position: fixed;
  top: 5%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}

.btnArea {
  display: flex;
  justify-content: end;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 130px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 82px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}

.organization_add_btn {
  margin-left: 10px;
  width: 50px;
  height: 33px;
  background-color: #604af3;
  color: white;
}
.layout-img {
  width: 80px;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/MeetingLayoutDialog.vue